// Campus photo for /colleges/duke-university: CC BY-SA 4.0, by Sdkb, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADuke_University_Chapel_side_in_July_2025.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/duke-university/; credited under the photo.
const photo = {
    "slug": "duke-university",
    "alt": "The stone side of Duke University Chapel above a garden walk at Duke University in Durham, North Carolina",
    "src": "/colleges/duke-university/campus-1600.webp",
    "srcSmall": "/colleges/duke-university/campus-800.webp",
    "srcMid": "/colleges/duke-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/duke-university/og.jpg",
    "title": "Duke University Chapel side in July 2025",
    "author": "Sdkb",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADuke_University_Chapel_side_in_July_2025.jpg",
    "read": "2026-10-01"
};

export default photo;
